// import moment from 'moment';
import Model from 'lib/Model';
import { v4 as uuid } from 'uuid';
// import ImgView from 'view/img';


export default Model.extend({
	defaults: function( attrs )
	{
		return {
			created_at: (new Date()).getTime(), uuid: uuid()
		}
	},

	toString: function() {
		return this.has('id') ? 'image n°'+this.get('id') : 'nouvelle image';
	},

	idAttribute: 'uuid',

	// getLastModified: function()
	// {
	// 	return 0;
	// },

	getChoices: function()
	{
		return {
			"":"",
			todo: "Une libellule est identifiable sur cette photo",
			pond: "Il n'y a pas de libellule identifiable sur cette photo"
		};
	},

	validate: function( attrs )
	{
		if( !_.has( attrs, 'name' ) )
		{
			return { name: 'Veuillez sélectionner une image', error: "Aucun image sélectionnée… ?" };
		}

		if( !_.has( attrs, 'date' ) )
		{
			return  { date: "Veuillez spécifier la date de prise de la photo" }
		}

		if( ( '1900-01-01' > attrs.date ) || ( attrs.date > (new Date()).toISOString().substr(0,10) ) )
		{
			return { date: "Veuillez choisir une photo prise entre 1900 et aujourd'hui" };
		}

		if( !_.has( attrs, 'status' ) || !_.contains( [ 'todo', 'pond' ], attrs.status ) )
		{
			return { status: "Ce champ est obligatoire" }
		}

		if( !attrs.agreement )
		{
			return { agreement: "Veuillez lire et confirmer ce point" }
		}

		var pond = this.getPond();
		if( !pond || pond.hasError() )
		{
			// 			Je ne veux pas afficher cette erreur, mais juste éviter l'envoi de l'image si le signalement est buggé
			return { pond: "La mares n'est pas définie" };
		}
	},

	save: function( data, options )
	{
		if( data )
		{
			this.set( data );
		}

		if( !this.isValid() )
		{
			return false;
		}

		var method = this.isNew() ? 'create' : 'update';

		// Mise à jour = on envoi sans le fichier image
		if( !this.isNew() )
		{
			// Envoi normal…
			return this.sync( 'update', this, options );
		}


		// création = on ajoute le fichier image en DATA_URL au données envoyées
		var deferred = $.Deferred();

		// Les données de base à envoyer
		options = _.extend( { attrs: this.toJSON() }, options );

		// On essaye de lire le data-url et après on envoi
		var loader = this.readAsDataURL();
		loader.done( function( data ) { options.attrs.data = data; } ).always(_.bind(function()
		{
			var xhr = this.sync( method, this, options );
			if( !xhr )
			{
				deferred.reject();
			}
			else
			{
				xhr.done( deferred.resolve );

				xhr.fail( deferred.reject );
			}
		},this));
		loader.fail( deferred.reject );

		return deferred;
	},


	setPond: function( pond )
	{
		this.set( 'pond_uuid', pond.get('uuid') );

		this.Pond = pond;
	},

	getPond: function()
	{
		return this.Pond || null;
	},

	setUser: function( user )
	{
		this.set( 'user_uuid', user.get('uuid') );
	},


	// Nom du fichier en local
	getPath: function()
	{
		return this.get('uuid')+'.jpg';
	},


	// Système anti mauvais cache
	getTime: function()
	{
		return this.has('updated_at') ? this.get('updated_at') : (new Date()).getTime();
	},





	toHTML: function( tag, attr )
	{
		var el = document.createElement( tag || 'span' );
		for( var k in attr || {} ) { el.setAttribute( k, attr[k] ); }

		el.setAttribute( 'id', 'img-'+this.get('uuid') );
		el.classList.add('img-gow');

		// Src déjà en mémoire (blob local ou distant)
		if( this.src )
		{
			el.style.backgroundImage = 'url(' + this.src + ')';
		}
		// Sinon charger depuis le stockage local, puis l'URL distante si besoin
		else
		{
			// Nouvelle image : blank ; sinon tiny (LQIP) si dispo, sinon unavailable
			var fallback = ( this.isNew() && !this.get('url') )
				? 'img/photo_blank.png'
				: ( this.get('tiny') || 'img/photo_unavailable.png' );

			el.style.backgroundImage = 'url(img/photo_loader.gif)';

			var loader = this.loadSrc();
			loader.done( _.bind( this.render, this ) );
			loader.fail( _.bind( function()
			{
				// Mémoriser le fallback pour ne pas rester sur le loader au prochain render
				this.src = fallback;
				this.render( fallback );
			}, this ) );

			// Échec déjà connu (ex. 404) : appliquer tout de suite, le nœud n'est pas encore au DOM
			if( this.src )
			{
				el.style.backgroundImage = 'url(' + this.src + ')';
			}
		}

		return el.outerHTML;
	},


	render: function( src )
	{
		$( "#img-" + this.get('uuid') ).css( 'background-image', 'url(' + src + ')' ).filter('a').attr( 'href', src );
	},


	// Essaye de charger l'image
	src: null,
	loadSrc: function()
	{
		var deferred = $.Deferred();

		// Déjà chargée
		if( this.src )
		{
			return deferred.resolve( this.src );
		}

		var path = this.getPath();
		console.log( 'Image', this.getPath(), 'loading…' );
		deferred.done( function( src ) { console.log( 'Image', path, 'load OK', src ); } );
		deferred.fail( function( err ) { console.warn( 'Image', path, 'load NO', err ); } );

		// Quand réussite, on sauvegarde le résultat
		deferred.done( _.bind( function( src ) { this.src = src; }, this ) );

		var success = function( blob ) { deferred.resolve( URL.createObjectURL( blob ) ) };

		// Nous allons essayer de le trouver en local
		var opener = this.getOpener();
		opener.done( function( blob ) { deferred.resolve( URL.createObjectURL( blob ) ) } );

		// Et enfin, de le télécharger et de le sauvegarde
		opener.fail( _.bind( function()
		{
			// Pas d'URL… C'est mort :(
			if( !this.get('url') )
			{
				return deferred.reject();
			}

			var dowloader = this.getDownloader();
			dowloader.done( function( blob ) { deferred.resolve( URL.createObjectURL( blob ) ) } );
			dowloader.fail( deferred.reject );

		}, this ) );

		return deferred;
	},


	saveSrc: function()
	{
		var path = this.getPath();
		var save = this.readAsBlob().then( function( blob )
		{
			return app.storage.write( 'image', path, blob );
		});

		console.log( 'Image', path, 'saving…' );
		save.done( _.partial( console.log, 'Image', path, 'save OK' ) );
		save.fail( _.partial( app.warn, 'Image', path, 'save NO' ) );

		return save;
	},


	// src => Blob
	readAsBlob: function()
	{
		var deferred = $.Deferred();

		var loader = this.loadSrc();
		loader.done( function( src )
		{
			var xhr = new XMLHttpRequest();
			xhr.open( 'GET', src, true );
			xhr.responseType = 'blob';

			xhr.onload = function() { deferred.resolve( this.response ); };

			xhr.onerror = deferred.reject;
			xhr.onabort = deferred.reject;

			xhr.send();
		});
		loader.fail( deferred.reject );

		return deferred;
	},

	readAsDataURL: function()
	{
		var deferred = $.Deferred();

		var loader = this.readAsBlob();
		loader.done( function( blob )
		{
			// Traduit en data-url
			var fr = new FileReader();
			fr.onload = function()
			{
				deferred.resolve( fr.result );
			};
			fr.onerror = deferred.reject;
			fr.onabort = deferred.reject;

			fr.readAsDataURL( blob );
		});
		loader.fail( deferred.reject );

		return deferred;
	},


	_opener: null,
	getOpener: function()
	{
		if( !this._opener )
		{
			var path = this.getPath();
			console.log( 'Image', this.getPath(), 'opening…' );
			this._opener = app.storage.open( 'image', this.getPath() );
			this._opener.done( function( blob ) { console.log( 'Image', path, 'open OK', blob ); } );
			this._opener.fail( function( text ) { console.warn( 'Image', path, 'open NO', text ); } );
		}
		return this._opener;
	},

	_dowloader: null,
	getDownloader: function()
	{
		if( !this._dowloader )
		{
			var deferred = this._dowloader = $.Deferred();

			var path = this.getPath();
			console.log( 'Image', this.getPath(), 'downloading…' );
			deferred.done( function( blob ) { console.log( 'Image', path, 'download OK', blob ); } );
			deferred.fail( function( text ) { console.warn( 'Image', path, 'download NO', text ); } );

			// Requête XHR de téléchargement
			var xhr = new XMLHttpRequest();

			xhr.open( "GET", this.get('url'), true );
			xhr.responseType = "blob";

			xhr.onload = _.bind( function( evt )
			{
				// 404 / autres erreurs HTTP : pas d'image à afficher
				if( xhr.status < 200 || xhr.status >= 300 )
				{
					return deferred.reject( xhr.status );
				}

				deferred.resolve( xhr.response );

				// => Puis écriture dans le système de fichier
				app.storage.write( 'image', this.getPath(), xhr.response );
			}, this );

			xhr.onerror = deferred.reject;
			xhr.onabort = deferred.reject;

			xhr.send( null );
		}

		return this._dowloader;
	},
});
